const BINDING_CHANNEL_STATUS_LABELS = {
  wecomStatus: {
    PREMATCHED: '已预匹配',
    UNBOUND: '未绑定',
    BOUND: '已绑定'
  },
  wechatNoticeStatus: {
    AUTHORIZED: '已授权',
    UNAUTHORIZED: '未授权'
  }
};

function padDatePart(value) {
  return String(value).padStart(2, '0');
}

export function formatBindingDateTime(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(text)) return text;
  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return text;
  return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())} ${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}:${padDatePart(date.getSeconds())}`;
}

export function translateBindingChannelStatus(field, value) {
  const key = String(field || '').trim();
  const status = String(value || '').trim().toUpperCase();
  if (!status) return '';
  const mapping = BINDING_CHANNEL_STATUS_LABELS[key] || {};
  return mapping[status] || status;
}

export function buildBindingChannelStatusTag(field, value) {
  const text = translateBindingChannelStatus(field, value);
  const type = ['已绑定', '已授权'].includes(text)
    ? 'success'
    : ['未绑定', '未授权'].includes(text)
      ? 'danger'
      : 'info';
  return { type, text };
}
